export const RESOURCE = {
    HEALTH: 'health',
    SANITY: 'sanity',
    SUPPLIES: 'supplies',
    FAME: 'fame'
}